module.exports = __webpack_public_path__ + "img/logo-github.54af2126.svg";